import type { SftpSettings, SshKey } from '@mcpanel/core';
import { rawRequest } from './client';
export const apiSftp = {
  settings: () => rawRequest<SftpSettings>('GET', '/me/sftp'),
  setName: (name: string) => rawRequest<SftpSettings>('PUT', '/me/sftp', { name }),
  keys: () => rawRequest<SshKey[]>('GET', '/me/ssh-keys'),
  addKey: (name: string, publicKey: string) => rawRequest<SshKey>('POST', '/me/ssh-keys', { name, publicKey }),
  removeKey: (id: string) => rawRequest<void>('DELETE', `/me/ssh-keys/${encodeURIComponent(id)}`),
};
